export default {
    manage_createEditVehicleStatus_EditTitle: "Edit Status Label",
    manage_createEditVehicleStatus_CreateTitle: "Create new Status Label",
    manage_createEditVehicleStatus_success: "Status Label was created successfully",
    manage_createEditVehicleStatus_success_edit: "Status Label was updated successfully",
    manage_createEditVehicleStatus_warning: "make a change to be able to save",
    manage_createEditVehicleStatus_warning_characters: "The name contains illegal characters, please make a change.",
    manage_createEditVehicleStatus_NameInputLabel: "Status Label",
    manage_createEditVehicleStatus_IconInputLabel: "Icon",
    manage_createEditVehicleStatus_duplicatedVehicleStatusErrorMessage: "This Status Label already exists",
  };
  